import TextField from 'apollo-react/components/TextField';
import React, { useCallback } from 'react';

import ZoomControl from './Zoom';
import {
  ADMIN_DISTRIBUTION_FOR_DETAILS,
  DISTRIBUTION_FOR_DETAILS,
} from '../../constants/SmartInsightConstants';

const ZoomCell = ({ row, isAutoCompleteLoading = false, column: { accessor: key } }) => {
  const savedSearchDetails = row.isAdmin
    ? ADMIN_DISTRIBUTION_FOR_DETAILS[row.distributionFor]
    : DISTRIBUTION_FOR_DETAILS[row.distributionFor];

  const error = row.errors?.find((error) => error?.controlInfo?.prop === key);

  const handleOnSelect = useCallback(
    (selection) => {
      row.handleZoomSelect({ row, selection });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className={row?.classes?.controlWrapper}>
      <TextField
        fullWidth
        value={row.code}
        required
        asteriskPosition="before"
        error={!!error}
        style={{ margin: 0 }}
      />
      <ZoomControl
        isAutoCompleteLoading={isAutoCompleteLoading}
        title={savedSearchDetails?.title ?? ''}
        entityName={savedSearchDetails?.entityName ?? ''}
        savedSearchName={savedSearchDetails?.savedSearchName ?? ''}
        handleOnSelect={handleOnSelect}
        multiSelect
        inTable
      />
    </div>
  );
};

export default ZoomCell;
